module.exports = "/_next/static/images/communication-illustration-6dc1d76a08dc38ca59104d1dd6165d90.svg";